<template>
  <div :class="classes">
    <place-detail v-show="showPlace" />
    <place-list v-show="showPlaceList" />
    <busstop-detail v-if="reservationMode" v-show="showBusstopDetail" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PlaceDetail from './PlaceDetail'
import PlaceList from './PlaceList'
import BusstopDetail from './BusstopDetail'

export default {
  components: {
    PlaceDetail,
    PlaceList,
    BusstopDetail
  },
  data () {
    return {
      block: 'hidden',
      show: false
    }
  },
  computed: {
    ...mapGetters({
      selectedPlace: 'drawer/getSelectedPlace',
      showPlaceFull: 'drawer/getShowPlaceFull',
      isOpen: 'drawer/getIsOpen',
      component: 'drawer/getComponent',
      forceOpen: 'drawer/getForceOpen',
      reservationMode: 'reservation/getMode'
    }),
    showPlace: function () {
      return this.component == 'PlaceDetail'
    },
    showPlaceList: function () {
      return this.component == 'PlaceList'
    },
    showBusstopDetail: function () {
      return this.component == 'BusstopDetail'
    },
    drawerHeight: function () {
      if (this.showPlaceList ) {
        return 'h-52'
      } else if (this.showBusstopDetail) {
        return 'h-64'
      } else  {
        return this.showPlaceFull ? 'h-96' : 'h-32'
      }
    },
    classes: function () {
      const base = ['transform', 'absolute', 'bg-white', 'bottom-0', 'w-full', 'ease-in-out', 'transition-all', 'duration-300', 'z-10']
      base.push(this.forceOpen ? 'block' : this.block)
      base.push(this.forceOpen || this.show ? 'translate-y-0' : 'translate-y-all')
      base.push(this.drawerHeight)

      return base
    }
  },
  watch: {
    // NOTE: 上下にスライドする感じのトランジションを効かすために要素の表示タイミングを調整
    isOpen: function (val) {
      if (val) {
        this.block = 'block'
        setTimeout(() => {
          this.show = true
        }, 200)
      } else {
        setTimeout(() => {
          this.block = 'hidden'
        }, 400)
        this.show = false
      }
    }
  }
}
</script>
